import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { bool, string, element, func, arrayOf, shape } from 'prop-types';
import styled from 'styled-components';
import 'react';
import { visuallyHiddenStyles } from '../../utils/styleHelpers.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _templateObject, _templateObject2;
const HiddenSubNav = /*#__PURE__*/styled.ul.withConfig({
  displayName: "seoSubNav__HiddenSubNav",
  componentId: "sc-1f369co-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), visuallyHiddenStyles);
const SeoMenuItem = /*#__PURE__*/styled.a.withConfig({
  displayName: "seoSubNav__SeoMenuItem",
  componentId: "sc-1f369co-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
const SeoSubNavItem = _ref => {
  let {
    children,
    name,
    to
  } = _ref;
  return /*#__PURE__*/jsxs("li", {
    children: [/*#__PURE__*/jsx(SeoMenuItem, {
      as: to ? 'a' : 'span',
      href: to,
      children: name
    }), children ? /*#__PURE__*/jsx(SeoSubNav, {
      data: children
    }) : null]
  });
};
const SeoSubNav = _ref2 => {
  let {
    data
  } = _ref2;
  return /*#__PURE__*/jsx(HiddenSubNav, {
    children: data.map((_ref3, i) => {
      let {
        name,
        ...rest
      } = _ref3;
      return /*#__PURE__*/jsx(SeoSubNavItem, {
        name: name,
        index: i,
        ...rest
      }, "".concat(name, "-").concat(i));
    })
  });
};
const menuItemShape = {
  active: bool,
  divider: bool,
  href: string,
  icon: element,
  name: string.isRequired,
  onClick: func,
  primary: bool,
  rtl: bool,
  to: string,
  type: string
};
menuItemShape.children = arrayOf(shape(menuItemShape));

export { SeoSubNav };
